import { parse as parseHTML } from 'node-html-parser';

export const stripHtml = (rawHtml?: string | null): string => {
  if (!rawHtml) return '';

  return parseHTML(rawHtml).structuredText.replaceAll('\n', ' ');
};
